import React from 'react';
import { Button } from '@mui/material';

interface Props {
  submitButtonDisabled: boolean;
  resetButtonDisabled: boolean;
  resetHandler: () => void;
}

const FooterForm: React.FC<Props> = ({
  submitButtonDisabled,
  resetButtonDisabled,
  resetHandler,
}) => (
  <div className="buttons">
    <Button
      type="button"
      color="secondary"
      onClick={resetHandler}
      disabled={resetButtonDisabled}
    >
      Reset
    </Button>
    <Button type="submit" disabled={submitButtonDisabled}>
      Submit
    </Button>
  </div>
);

export default FooterForm;
